import type { Networkish } from "@/types";
import { isNativeToken } from "@/utils";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useMemo } from "react";

import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { getAddress, type Address } from "viem";
import { useReadContract } from "wagmi";
import { getERC20Abi } from "@/abis/erc20";

export default function useERC20Allowance(watch: boolean, token?: Address, spender?: Address, chainId?: Networkish) {
  const { network } = useDynamicContext();
  const owner = useWeb3UserAddress();
  const args = useMemo(() => [owner || "", spender || ""], [owner, spender]);

  const chainIdInt = parseInt(`${chainId}`);

  const formattedToken = token ? getAddress(token) : token;

  const enabled = useMemo(() => {
    return !!token && !!spender && !!owner && !isNativeToken({ address: token }) && parseInt(`${network}`) === chainIdInt;
  }, [token, spender, owner, chainIdInt, network]);

  const { data } = useReadContract({
    address: formattedToken,
    abi: getERC20Abi(formattedToken, chainIdInt),
    chainId: chainIdInt,
    functionName: "allowance",
    args: args as [Address, Address],
    query: {
      enabled: enabled,
      refetchInterval: watch ? 3000 : false,
    },
  });
  return useMemo(() => (data !== undefined && token ? data : undefined), [data, token]);
}
